module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex jc-center ai-center fd-column pa-4"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 45,
      "width": 4,
      "color": "primary",
      "indeterminate": ""
    }
  }), _c('span', {
    staticClass: "mt-4 font-weight-700"
  }, [_vm._v("Estamos activando tu cuenta")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b4520d0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Verificar_email.vue
// module id = 514
// module chunks = 1